module.exports = __webpack_public_path__ + "static/media/4.9_preview.caf83223.png";